import React, { useMemo, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FiArrowRight } from "react-icons/fi";
import { LuChevronLeft, LuChevronRight } from "react-icons/lu";
import { caseStudiesData } from "../data/caseStudiesData";
import "../assets/css/CaseStudies.css";
import { caseStudyImages } from "../data/caseStudyImages";

const CaseStudies = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const filtersRef = useRef(null);

  const categories = useMemo(() => {
    return ["All", ...new Set(caseStudiesData.map((item) => item.category))];
  }, []);

  const filteredStudies =
    activeCategory === "All"
      ? caseStudiesData
      : caseStudiesData.filter((item) => item.category === activeCategory);

  const scrollFilters = (direction) => {
    filtersRef.current?.scrollBy({
      left: direction * 300,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Navbar />

      <div className="case-studies-page">
        <section className="case-hero">
          <span className="case-badge">CASE STUDIES</span>

          <h1>Proven Frameworks & Insights</h1>

          <p>
            Learn directly from the world's best teams. Get immediate access to
            hands-on guides, proven frameworks, and real-world insights.
          </p>
        </section>

        <section className="case-filters-wrapper">
          <button
            className="case-scroll-btn"
            onClick={() => scrollFilters(-1)}
            aria-label="Scroll case study filters left"
          >
            <LuChevronLeft />
          </button>

          <div ref={filtersRef} className="case-filters">
            {categories.map((category) => (
              <button
                key={category}
                className={`case-filter-btn ${
                  activeCategory === category ? "active" : ""
                }`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          <button
            className="case-scroll-btn"
            onClick={() => scrollFilters(1)}
            aria-label="Scroll case study filters right"
          >
            <LuChevronRight />
          </button>
        </section>

        <section className="case-grid">
          {filteredStudies.map((study) => (
            <article key={study.id} className="case-card">
              <div className="case-image">
                <img
                      src={caseStudyImages[study.image]}
                      alt={study.title}
                      loading="lazy"
                      decoding="async"
                    />
              </div>

              <div className="case-content">
                <h3>{study.title}</h3>

                <p>{study.cardDescription}</p>

                <NavLink
                  to={`/case-studies/${study.slug}`}
                  className="case-link"
                >
                  Read Case Study
                  <FiArrowRight />
                </NavLink>
              </div>
            </article>
          ))}
        </section>

        <section className="case-cta">
          <div className="case-cta-content container">
            <h2>Recovery That Doesn't Cost You the Relationship</h2>

            <p>
              Book a consultation and see how insight-based, compliance-first AI
              collections can improve recovery without damaging customer trust.
            </p>

            <button className="ccsnl-btn">
                <NavLink to="/contact-us" className="text-white">
                 Request a Consultation
                </NavLink>
            </button>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default CaseStudies;
